import React from 'react';
import './ActivityStatBox.css';
import {
  formatReadableDate,
  GLOBAL_COLORS,
  secondsToDaysHoursAndMinutes,
} from '../../hooks/helpers';
import { PiBookOpenThin } from 'react-icons/pi';
import { FaCheck } from 'react-icons/fa';
import { BsClock } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';

export const ActivityStatBox = (props) => {
  const { t } = useTranslation('library');

  return (
    <>
      {props.userActivityDataLoaded && (
        <>
          <div className="div-block-494 first">
            <div>
              <div className="div-block-476">
                <div className="div-block-454">
                  <PiBookOpenThin
                    className={'image-169 activity-icon'}
                    color={GLOBAL_COLORS.icon_color}
                  />
                </div>
                <div>
                  <div className="text-block-250">{t('Last Accessed')}</div>
                  <div className="text-block-245 smaller">
                    {formatReadableDate(
                      props.userActivityData.data.last_activity
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="div-block-494">
            <div>
              <div className="div-block-476">
                <div className="div-block-454">
                  <FaCheck
                    className={'image-169 activity-icon'}
                    color={GLOBAL_COLORS.icon_color}
                  />
                </div>
                <div>
                  <div className="text-block-250">{t('Joined')}</div>
                  <div className="text-block-245 smaller">
                    {formatReadableDate(
                      props.userActivityData.data.date_joined
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="div-block-494">
            <div>
              <div className="div-block-476">
                <div className="div-block-454">
                  <BsClock
                    className={'image-169 activity-icon'}
                    color={GLOBAL_COLORS.icon_color}
                  />
                </div>
                <div>
                  <div className="text-block-250">{t('Total Time Spent')}</div>
                  <div className="text-block-245 smaller">
                    {secondsToDaysHoursAndMinutes(
                      props.userActivityData.data.total_time_spent
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
